// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KeywordFilterItem__item-container-f51937 {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  height: 48px;
  padding: 0px 24px;
}

.KeywordFilterItem__text-d9b66f {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-110);
}

.KeywordFilterItem__button-de1f88 {
  margin-inline-start: 24px;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/KeywordFiltersPopup/KeywordFilterItem/KeywordFilterItem.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;AACF;;AAEA;EACE,OAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,wBAAA;EACA,0CAAA;EACA,sBAAA;AACF;;AAEA;EACE,yBAAA;AACF","sourcesContent":[".item-container {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  height: 48px;\n  padding: 0px 24px;\n}\n\n.text {\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-110);\n}\n\n.button {\n  margin-inline-start: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item-container": `KeywordFilterItem__item-container-f51937`,
	"itemContainer": `KeywordFilterItem__item-container-f51937`,
	"text": `KeywordFilterItem__text-d9b66f`,
	"button": `KeywordFilterItem__button-de1f88`
};
module.exports = ___CSS_LOADER_EXPORT___;
